import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const addEmail = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/clients/subscribeEmail`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const getEmails = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/clients/getSubscribedEmails`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        return err;
    }
};

export const deleteEmail = async (emailId) => {
    const options = {
        url: `${Variable.backendUrl}/clients/deleteEmail/${emailId}`,
        method: 'DELETE'
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
    }
};
